/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const HealthIcon = /*#__PURE__*/ createSvgIcon(
  'HealthIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9 10.5v1.438a.55.55 0 00.156.406.55.55 0 00.406.156h.875c.18 0 .32-.052.417-.156a.572.572 0 00.146-.406V10.5h1.437c.18 0 .32-.052.417-.156A.572.572 0 0013 9.938v-.875c0-.181-.049-.32-.146-.417-.097-.097-.236-.146-.417-.146H11V7.063c0-.181-.049-.32-.146-.417-.097-.097-.236-.146-.417-.146h-.875a.571.571 0 00-.406.146c-.104.097-.156.236-.156.417V8.5H7.562a.571.571 0 00-.406.146c-.104.097-.156.236-.156.417v.875a.55.55 0 00.156.406.55.55 0 00.406.156H9zm1 7.417c-.084 0-.167-.004-.25-.01a.789.789 0 01-.23-.053c-1.819-.597-3.277-1.701-4.374-3.312C4.048 12.93 3.5 11.174 3.5 9.27V5.52a1.461 1.461 0 01.958-1.396l5-1.917A1.5 1.5 0 0110 2.104c.18 0 .36.035.541.104l5 1.917a1.462 1.462 0 01.959 1.396v3.75c0 1.903-.549 3.66-1.646 5.27-1.097 1.612-2.556 2.716-4.375 3.313a.788.788 0 01-.23.052c-.083.007-.166.01-.25.01zm0-1.48c1.444-.444 2.639-1.34 3.583-2.687A7.628 7.628 0 0015 9.27V5.52l-5-1.916-5 1.917v3.75c0 1.639.472 3.132 1.416 4.48.945 1.346 2.14 2.242 3.584 2.687z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default HealthIcon;
